import { useEffect, useState } from "react";
import { Download, HandCoins } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, gbp } from "../lib/api";

const monthName = (m) => new Date(`${m}-01T00:00:00`).toLocaleDateString("en-GB", { month: "short", year: "numeric" });

export function DirectProsReport() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/reports/direct-pros").then((r) => setD(r.data)).catch((e) => toast.error(errMsg(e))); }, []);
  if (!d) return null;
  const csv = async () => {
    const r = await api.get("/admin/reports/direct-pros", { params: { format: "csv" }, responseType: "blob" });
    const a = document.createElement("a"); a.href = URL.createObjectURL(r.data); a.download = "direct-payment-pros.csv"; a.click();
  };
  const tot = d.rows.reduce((s, r) => ({ up: s.up + r.uplift_income, cm: s.cm + r.platform_commission }), { up: 0, cm: 0 });
  return (
    <section className="card p-5" data-testid="direct-pros-report">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-3">
        <h2 className="font-bold flex items-center gap-2"><HandCoins size={17} className="text-[#FF8166]" />Direct-payment pros</h2>
        <button onClick={csv} className="btn-ghost btn-sm" data-testid="direct-pros-csv-btn"><Download size={14} />CSV</button>
      </div>
      <div className="flex flex-wrap gap-2 text-xs mb-4">
        <span className="chip bg-slate-100" data-testid="direct-pros-current">{d.current_direct} take payments directly</span>
        <span className="chip bg-emerald-50 text-emerald-700" data-testid="platform-pros-current">{d.current_platform} use MyHomelyHub payments</span>
        <span className="chip bg-amber-50 text-amber-700" data-testid="undecided-pros-current">{d.undecided} still to choose</span>
        <span className="chip bg-slate-100" data-testid="direct-pros-12m">12 months: {gbp(tot.up)} uplift income · {gbp(tot.cm)} platform commission</span>
      </div>
      <div className="overflow-x-auto"><table className="w-full text-sm"><thead className="bg-slate-50 text-left"><tr>
        <th className="p-2">Month</th><th className="p-2">Direct pros</th><th className="p-2">Platform pros</th><th className="p-2">Uplift purchases</th><th className="p-2">Uplift income</th><th className="p-2">Platform commission</th></tr></thead>
        <tbody>{d.rows.map((r) => (
          <tr key={r.month} className="border-t border-slate-100" data-testid={`direct-pros-row-${r.month}`}>
            <td className="p-2">{monthName(r.month)}</td><td className="p-2">{r.direct_pros}</td><td className="p-2">{r.platform_pros}</td><td className="p-2">{r.uplift_purchases}</td>
            <td className="p-2 font-semibold">{gbp(r.uplift_income)}</td><td className="p-2">{gbp(r.platform_commission)}</td></tr>))}</tbody></table></div>
      <p className="text-xs muted mt-2">Pro counts are at the end of each month, from when pros chose or changed how they take payments.</p>
    </section>
  );
}
